import HomeToGo from './HomeToGo.svg';
export const hometogo = HomeToGo;
//# sourceMappingURL=index.js.map